export const InfoUserURL = "/api/v1/info_user";
export const ListUserURL = "/api/v1/list_user";
export const CreateUserURL = "/api/v1/add_user";
export const DeleteUserURL = "/api/v1/delete_user";
export const EditUserURL = "/api/v1/update_user";
export const ValidateUserURL = "/api/v1/validate_user";
export const LogoutUserURL = "/api/v1/logout_user";
export const GetLoginPublicKeyURL = "/api/v1/get_login_public_key";
export const ChangePasswordURL = "/api/v1/change_password";
export const BatchResetUserPasswordURL = "/api/v1/batch_reset_user_password";
export const ListMiniProgramUserBindingURL = "/api/v1/mini-program-binding/list";
export const ListMiniProgramCustomerURL = "/api/v1/mini-program-binding/customer_list";
export const BindMiniProgramUserURL = "/api/v1/mini-program-binding/bind";
export const UnbindMiniProgramUserURL = "/api/v1/mini-program-binding/unbind";

export const ListRoleURL = "/api/v1/list_role";
export const CreateRoleURL = "/api/v1/create_role";
export const UpdateRoleURL = "/api/v1/update_role";

export const ListDepartmentURL = "/api/v1/list_department";
export const CreateDepartmentURL = "/api/v1/create_department";
export const DeleteDepartmentURL = "/api/v1/delete_department";
export const UpdateDepartmentURL = "/api/v1/update_department";

export const ListMenuURL = "/api/v1/list_menu";
export const MineMenuURL = "/api/v1/list_menu/mine";
export const CreateMenuURL = "/api/v1/create_menu";
export const DeleteMenuURL = "/api/v1/delete_menu";
export const UpdateMenuURL = "/api/v1/update_menu";

export const ListDictionaryURL = "/api/v1/list_dictionary";
export const CreateDictionaryURL = "/api/v1/create_dictionary";
export const UpdateDictionaryURL = "/api/v1/update_dictionary";
export const DeleteDictionaryURL = "/api/v1/delete_dictionary";
export const ListDictionaryValueURL = "/api/v1/list_dictionary_value";
export const CreateDictionaryValueURL = "/api/v1/create_dictionary_value";
export const UpdateDictionaryValueURL = "/api/v1/update_dictionary_value";
export const DeleteDictionaryValueURL = "/api/v1/delete_dictionary_value";

export const UPLOAD_FILE = "/api/v1/upload_file";
export const LIST_FILE_URL = "/api/v1/list_file";
export const DEFAULT_COVER_PATH = "/api/v1/default-cover.svg";
export const DEFAULT_COVER_OBJECT_KEY = "builtin:default-cover";

export const ReservationConfigURL = {
  List: "/api/v1/reservation-config/list",
  Detail: "/api/v1/reservation-config/detail",
  Create: "/api/v1/reservation-config/create",
  Update: "/api/v1/reservation-config/update",
  Delete: "/api/v1/reservation-config/delete",
  ChangeStatus: "/api/v1/reservation-config/change_status",
};

export const ParkClosureURL = {
  List: "/api/v1/park-closure/list",
  Create: "/api/v1/park-closure/create",
  Delete: "/api/v1/park-closure/delete",
};

export const LocationURL = {
  List: "/api/v1/location/list",
  Detail: "/api/v1/location/detail",
  Create: "/api/v1/location/create",
  Update: "/api/v1/location/update",
  Delete: "/api/v1/location/delete",
  ChangeStatus: "/api/v1/location/change_status",
};

export const PersonalReservationURL = {
  List: "/api/v1/personal-reservation/list",
  Detail: "/api/v1/personal-reservation/detail",
  TestCreate: "/api/v1/personal-reservation/test_create",
};

export const TeamRegistrationURL = {
  List: "/api/v1/team-registration/list",
  Detail: "/api/v1/team-registration/detail",
  TestCreate: "/api/v1/team-registration/test_create",
  Approve: "/api/v1/team-registration/approve",
};

export const StudyReservationURL = {
  List: "/api/v1/study-reservation/list",
  Detail: "/api/v1/study-reservation/detail",
  TestCreate: "/api/v1/study-reservation/test_create",
  Approve: "/api/v1/study-reservation/approve",
};

export const GuideContentURL = {
  UploadMedia: "/api/v1/guide-content/upload_media",
  ManageList: "/api/v1/guide-content/manage_list",
  ManageDetail: "/api/v1/guide-content/manage_detail",
  Create: "/api/v1/guide-content/create",
  Update: "/api/v1/guide-content/update",
  Delete: "/api/v1/guide-content/delete",
  ChangeStatus: "/api/v1/guide-content/change_status",
  GenerateQRCode: "/api/v1/guide-content/qr/generate",
  DownloadQRCode: "/api/v1/guide-content/qr/download",
  PublicQRCodeDetail: "/api/v1/guide-content/qr/public_detail",
};

export const GuideTopicURL = {
  UploadCover: "/api/v1/guide-topic/upload_cover",
  ManageList: "/api/v1/guide-topic/manage_list",
  ManageDetail: "/api/v1/guide-topic/manage_detail",
  Options: "/api/v1/guide-topic/options",
  Create: "/api/v1/guide-topic/create",
  Update: "/api/v1/guide-topic/update",
  Delete: "/api/v1/guide-topic/delete",
  ChangeStatus: "/api/v1/guide-topic/change_status",
};

export const RelicURL = {
  UploadImage: "/api/v1/relic/upload_image",
  ManageList: "/api/v1/relic/manage_list",
  ManageDetail: "/api/v1/relic/manage_detail",
  Create: "/api/v1/relic/create",
  Update: "/api/v1/relic/update",
  Delete: "/api/v1/relic/delete",
  ChangeStatus: "/api/v1/relic/change_status",
};

export const SiteURL = {
  UploadImage: "/api/v1/site/upload_image",
  ManageList: "/api/v1/site/manage_list",
  ManageDetail: "/api/v1/site/manage_detail",
  Create: "/api/v1/site/create",
  Update: "/api/v1/site/update",
  Delete: "/api/v1/site/delete",
  ChangeStatus: "/api/v1/site/change_status",
};

export const MaterialServiceURL = {
  ListModel3Ds: "/api/v1/material/model3d/list",
  UploadModel3D: "/api/v1/material/model3d/upload",
};

export const InternetAccessURL = {
  List: "/api/v1/internet-access/list",
  Detail: "/api/v1/internet-access/detail",
  Approve: "/api/v1/internet-access/approve",
};

export const FeedbackURL = {
  List: "/api/v1/feedback/manage_list",
};

export const OperationLogURL = {
  List: "/api/v1/operation-log/list",
  Detail: "/api/v1/operation-log/detail",
};

export const WechatArticleURL = {
  Sync: "/api/v1/wechat_article/sync",
  List: "/api/v1/wechat_article/list",
};

export const StaticResourceURL = {
  Upload: "/api/v1/static-resource/upload",
  List: "/api/v1/static-resource/list",
  Detail: "/api/v1/static-resource/detail",
  Delete: "/api/v1/static-resource/delete",
};
